var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagJamaica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.8506C24.8366 32.8506 32 25.6871 32 16.8506C32 8.01403 24.8366 0.850586 16 0.850586C7.16344 0.850586 0 8.01403 0 16.8506C0 25.6871 7.16344 32.8506 16 32.8506Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.741 4.15809C23.0431 2.08427 19.6659 0.850586 16 0.850586C12.3341 0.850586 8.95688 2.08434 6.25894 4.15809L16 13.8991L25.741 4.15809Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30744 7.10938C1.23375 9.80731 0 13.1845 0 16.8504C0 20.5163 1.23375 23.8935 3.3075 26.5915L13.0486 16.8504L3.30744 7.10938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25894 29.5432C8.95694 31.6171 12.3341 32.8507 16 32.8507C19.6659 32.8507 23.0431 31.617 25.7411 29.5432L16 19.8022L6.25894 29.5432Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6922 26.5914C30.766 23.8934 31.9997 20.5163 31.9997 16.8504C31.9997 13.1845 30.766 9.80731 28.6922 7.10938L18.9512 16.8504L28.6922 26.5914Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagJamaica);
export default __webpack_public_path__ + "static/media/flag_jamaica.f6ac4c85b5eb1cbb356377ae766a2bdc.svg";
export { ForwardRef as ReactComponent };